var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDuotonePensionScheme = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 60,
  height: 60,
  viewBox: "0 0 60 60",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: ".local/icon-duotone-pension-scheme"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("g", {
  id: "Vector"
}, /*#__PURE__*/React.createElement("path", {
  d: "M46.8464 42.5514V52.316H12.9521V38.702V8H33.7957L46.8464 21.0507V36.3547",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46.8464 42.5514V52.316H12.9521V38.702V8H33.7957L46.8464 21.0507V36.3547",
  stroke: "#060707",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_2"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M10.5112 44.807H9.00895C5.7228 44.807 3 42.0842 3 38.798C3 35.5119 5.7228 32.7891 9.00895 32.7891H10.5112C13.7973 32.7891 16.5201 35.5119 16.5201 38.798C16.5201 42.0842 13.7973 44.807 10.5112 44.807Z",
  fill: "white",
  stroke: "#060707",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_3",
  d: "M31.1669 44.807H29.6647C26.3786 44.807 23.6558 42.0842 23.6558 38.798C23.6558 35.5119 26.3786 32.7891 29.6647 32.7891H31.1669C34.4531 32.7891 37.1759 35.5119 37.1759 38.798C37.2698 42.0842 34.547 44.807 31.1669 44.807Z",
  stroke: "#060707",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "square",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_4",
  d: "M16.0508 36.3565C18.8675 35.4176 21.8719 35.4176 24.5948 36.3565",
  stroke: "#060707",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_5",
  d: "M37.2695 35.9805H49.0058C50.508 35.9805 51.9163 36.5438 52.9491 37.6705L57.8314 42.5528",
  stroke: "#060707",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "Vector_6"
}, /*#__PURE__*/React.createElement("path", {
  d: "M46.1891 21.8029H32.9507V9.87891",
  fill: "#FF4389"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46.1891 21.8029H32.9507V9.87891",
  stroke: "#060707",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
}))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDuotonePensionScheme);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "duotone-pension-scheme.f030ca44c44a88244d5c01a3b5ee8d4f.svg";